import { fetchRequestPrev } from "@providers/conect_prev";

const verMedicosApi = async ( data ) => {

  try {
    const url = `integrations/previplan/consultar-medicos-disponibles`
    const response = await fetchRequestPrev(url, {
      method: "POST",
      body:{
        ...data 
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

export { verMedicosApi };
